/**
 * Platform Theme utilities for dark/light/system mode
 */

export const themes = Object.freeze({
  light: "light",
  dark: "dark",
  system: "system",
});

const THEME_STORAGE_KEY = "homy-platform-theme";

export function getTheme() {
  if (typeof window === "undefined") return themes.system;
  const stored = localStorage.getItem(THEME_STORAGE_KEY);
  if (stored && Object.values(themes).includes(stored)) {
    return stored;
  }
  return themes.system;
}

export function setTheme(theme) {
  if (typeof window === "undefined") return;
  const root = window.document.documentElement;

  const validTheme = Object.values(themes).includes(theme) ? theme : themes.system;
  localStorage.setItem(THEME_STORAGE_KEY, validTheme);

  if (validTheme === themes.system) {
    const isDark = window.matchMedia("(prefers-color-scheme: dark)").matches;
    root.classList.remove("dark");
    if (isDark) root.classList.add("dark");
  } else {
    root.classList.remove("dark");
    if (validTheme === themes.dark) {
      root.classList.add("dark");
    }
  }
}

export function initTheme() {
  if (typeof window === "undefined") return;
  const theme = getTheme();
  setTheme(theme);

  const mediaQuery = window.matchMedia("(prefers-color-scheme: dark)");
  const handleChange = (e) => {
    const current = getTheme();
    if (current === themes.system) {
      const root = window.document.documentElement;
      root.classList.remove("dark");
      if (e.matches) root.classList.add("dark");
    }
  };

  if (mediaQuery.addEventListener) {
    mediaQuery.addEventListener("change", handleChange);
  } else if (mediaQuery.addListener) {
    mediaQuery.addListener(handleChange);
  }
}
